import CONSTANTS from "@/constants"

export function getContentDetailedSkillsList(contentType, skillsList) {
  const levels = CONSTANTS.CONTENT_TYPE_SKILL_LEVELS
  const level = Object.prototype.hasOwnProperty.call(levels, contentType)
    ? levels[contentType]
    : CONSTANTS.SKILL_LEVELS.INVALID_SKILL_LEVEL
  if (!skillsList || !Array.isArray(skillsList) || level === CONSTANTS.SKILL_LEVELS.INVALID_SKILL_LEVEL) {
    return []
  }
  const filteredSkills = skillsList.filter(
    entry => entry.taxonomyPath && entry.taxonomyPath.length > level
  )
  return filteredSkills.map(entry => {
    return {
      level: level,
      name: entry.taxonomyPath[level].name,
      skillId: entry.skillId,
      taxonomyPath: entry.taxonomyPath
        .slice(0, level + 1)
        .map(t => t.name)
        .join(' > ')
    }
  })
}

export function isLeaf(contentType) {
  const level = CONSTANTS.CONTENT_TYPE_SKILL_LEVELS[contentType] || CONSTANTS.SKILL_LEVELS.INVALID_SKILL_LEVEL
  return level === CONSTANTS.SKILL_LEVELS.SKILL
}

export function taxonomyPathFromStrToArray(taxonomyPathStr) {
  if (!taxonomyPathStr || typeof taxonomyPathStr !== 'string') {
    return []
  }
  return taxonomyPathStr.split(' > ').map((name, index) => ({ level: index, name: name.trim() }))
}

export function adaptTaxonomySkillsToStore(taxonomySkills) {
  if (!taxonomySkills || !Array.isArray(taxonomySkills)) {
    return []
  }
  return taxonomySkills.map(ts => { return { skillId: ts.skill_id, taxonomyPath: ts.taxonomy_path } })
}